import React from "react";
import { errorToast } from "./common/showtoast";
import PageHeader from "./common/pageheader";
import ApiRequest from "./common/restservice";
import { Link } from "react-router-dom";

export default class Invoice extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tableData: []
    }
  }
  componentDidMount() {
    this.GetTransactions();
  }
  async GetTransactions() {
    let res = await ApiRequest("invoice.asp", "GET", null, { Authorization: localStorage.getItem("token") });
    console.log(res);
    if (res.status === "error") {
      errorToast(res.message);
      if (res.message === "Session Expired") {
        localStorage.clear();
        this.props.history.push("/login");
      }
      return;
    }
    this.setState({
      tableData: res.items
    })
  }
  render() {
    return (
      <div>
        <PageHeader title="Invoice" />
        <div className="row">
          <div className="col-xl-12 col-lg-12 col-md-12">
            <div className="card">
              <div className="card-header">
                <h3 className="card-title text-color-1" style={{ fontWeight: "200", fontSize: "22px" }}>
                                    Invoice
                </h3>
                                
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-vcenter text-nowrap mb-0 table-striped table-bordered border-top" style={{ textAlign: "center" }}>
                    <thead className="">
                      <tr>
                        <th>S.No</th>
                        <th>BillNo</th>
                        <th>Date</th>
                        <th>Modes</th>
                        <th>BV</th>
                        <th>Amount</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        this.state.tableData.length <= 0 ? <tr>
                          <td colSpan="7">No Details Found</td>
                        </tr> :
                          this.state.tableData.map((item, index) => (
                            <tr key={index}>
                              <td className="tabletd">{(index + 1)}</td>
                              <td>{item.Billnumber}</td>
                              <td>{item.date}</td>
                              <td>{item.Modes ? item.Modes : "-"}</td>
                              <td>{item.totalBV}</td>
                              <td>{item.totalMRP}</td>
                              <td><Link className="btn btn-primary ml-auto" to={`/invoicedetail/${item.Billnumber}`}>View</Link></td>
                            </tr>
                          ))
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}